const { handleRequest } = require("helpers");

export const fetchRoles = async (params = {}, filters = {}) => {
    try {
        const paramsString = Object.keys(params).map(key => `${key}=${params[key]}`).join('&');
        const filterString = Object.keys(filters).map(key => `${key}:${filters[key]}`).join(',');
        const res = await handleRequest(`/roles/?${paramsString}&filters=${filterString}`,);
        if (res.success && res.status === 200) {
            return res;
        }
        return {};
    } catch (e) {
        console.log(e);
    }
}


export const fetchRole = async (id) => {
    try {
        if (!id) {
            console.error('id is required');
            return;
        }
        const res = await handleRequest(`/roles/${id}`,);
        if (res.success && res.status === 200) {
            return res;
        }
        return {};
    } catch (e) {
        console.log(e);
    }
}

export const createRole = async (body = {}) => {
    try {
        const res = await handleRequest('/roles', 'POST', body);
        return res;
    } catch (e) {
        console.log(e);
    }
}

export const updateRole = async (id, body = {}) => {
    try {
        if (!id) {
            console.error('id is required');
            return;
        }
        const res = await handleRequest(`/roles/${id}`, 'PUT', body);
        return res;
    } catch (e) {
        console.log(e);
    }
}

export const deleteRole = async (id) => {
    try {
        if (!id) {
            console.error('id is required');
            return;
        }
        const res = await handleRequest(`/roles/${id}`, 'DELETE');
        if (res.success && res.status === 200) {
            return res;
        }
        return {};
    } catch (e) {
        console.log(e);
    }
}

/**
 * fetch all permissions
 * @returns {Promise<Array>}
 */
export const fetchPermissions = async (params = {}) => {
    try {
        const paramsString = Object.keys(params).map(key => `${key}=${params[key]}`).join('&');
        const res = await handleRequest(`/permissions/?${paramsString}`,);
        if (res.success && res.status === 200) {
            return res;
        }
        return [];
    } catch (e) {
        console.log(e);
    }
}

/**
 * create a new permission
 * @param {Object} body
 * @returns {Promise<Object>}
 */
export const createPermission = async (body = {}) => {
    try {
        const res = await handleRequest('/permissions', 'POST', body);
        if (res && res.success && res.status === 201) {
            return res;
        }
        return {};
    } catch (e) {
        console.log(e);
    }
}

/**
 * update a permission
 * @param {string} id
 * @param {Object} body
 * @returns {Promise<Object>}
 */
export const updatePermission = async (id, body = {}) => {
    try {
        if (!id) {
            console.error('id is required');
            return;
        }
        const res = await handleRequest(`/permissions/${id}`, 'PUT', body);
        if (res && res.success && res.status === 200) {
            return res;
        }
        return {};
    } catch (e) {
        console.log(e);
    }
}

/**
 * delete a permission
 * @param {string} id
 * @returns {Promise<Object>}
 */
export const deletePermission = async (id) => {
    try {
        if (!id) {
            console.error('id is required');
            return;
        }
        const res = await handleRequest(`/permissions/${id}`, 'DELETE');
        if (res && res.success && res.status === 200) {
            return res;
        }
        return {};
    } catch (e) {
        console.log(e);
    }
}

/**
 * fetch a permission
 * @param {string} id
 * @returns {Promise<Object>}
 */
export const fetchPermission = async (id) => {
    try {
        if (!id) {
            console.error('id is required');
            return;
        }
        const res = await handleRequest(`/permissions/${id}`,);
        if (res && res.success && res.status === 200) {
            return res;
        }
        return {};
    } catch (e) {
        console.log(e);
    }
}

/**
 * assign permissions to a role
 * @param {string} role_id
 * @param {Array} permissions
 * @returns {Promise<Object>}
 */
export const assignPermissionsToRole = async (role_id, permissions) => {
    try {
        const res = await handleRequest(`/permissions/assign-permissions/${role_id}`, 'POST', { permissions });
        if (res.success && res.status === 200) {
            return res;
        }
        return null;
    } catch (e) {
        console.log(e);
    }
}

export const fetchPermissionAgainstRole = async (role_id) => {
    try {
        const res = await handleRequest(`/permissions/get-permissions/${role_id}`);
        if (res.success && res.status === 200 && res.data?.length > 0) {
            return res;
        }
        return null;
    } catch (e) {
        console.log(e);
    }
}